import axios from 'axios';
import type { I18n } from 'vue-i18n';
import { useTranslationStore } from '@/stores/translation';
import { BUILD_TIMESTAMP } from '@/constants';

export default class TranslationService {
  private i18n: I18n;

  constructor(i18n: I18n) {
    this.i18n = i18n;
  }

  public refreshTranslation(newLanguage: string) {
    const translationStore = useTranslationStore();
    let currentLanguage = translationStore.currentLanguage;
    currentLanguage = newLanguage ? newLanguage : 'en';
    const globalI18n = this.i18n.global as any;
    if (this.i18n && !globalI18n.getLocaleMessage(currentLanguage)?.__loaded) {
      globalI18n.setLocaleMessage(currentLanguage, {});
      axios.get(`i18n/${currentLanguage}.json?buildTimestamp=${BUILD_TIMESTAMP}`).then(res => {
        if (res.data) {
          res.data.__loaded = true;
          globalI18n.setLocaleMessage(currentLanguage, res.data);
          globalI18n.locale.value = currentLanguage;
          translationStore.setCurrentLanguage(currentLanguage);
        }
      });
    } else if (this.i18n) {
      globalI18n.locale.value = currentLanguage;
      translationStore.setCurrentLanguage(currentLanguage);
    }
  }
}
